<template>
<div>
    <div v-if="value" class='item-actions'>
        <p-button type="success" size="sm" outline class="stacked" :disabled="loading" @click="sendCommand('ON')">
            <b-icon icon="power"/>
            <span>{{ $t('button.on') }}</span>
        </p-button>
        <p-button type="danger" size="sm" outline class="stacked" :disabled="loading" @click="sendCommand('OFF')">
            <b-icon icon="power"/>
            <span>{{ $t('button.off') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline class="stacked" :disabled="loading" @click="sendCommand('OFF_ON')">
            <b-icon icon="bootstrap-reboot"/>
            <span>{{ $t('button.reset2') }}</span>
        </p-button>
    </div>
    <RequestInfo :ok="ok" :error="error" :loader="loading"/>
</div>
</template>

<script>

export default {
    props: ['value'],
    data() {
        return {
            ok: false,
            error: false,
            loading: false
        }
    },
    watch: {
        value() {
            this.ok = this.error = this.loading = false;
        }
    },
    methods: {
        sendCommand: function(action) {
            this.ok = this.error = false;
            this.loading = true;
            const self = this;

            if (this.value) {
                this.$store.dispatch('powerSocket/sendCommand', { deviceId: this.value, command: action }).then(() => {
                  /*
                  this.$bvToast.toast(this.$t("power_sockets.command_sent"), {
                        title: this.$t('notify.notice'),
                        variant: 'success',
                        autoHideDelay: 2000,
                        toaster: 'paahdin'
                    })*/
                     setTimeout(() => { self.ok = true; self.loading = false; }, 1000);               
                }, () => {
                     setTimeout(() => { self.error = true; self.loading = false;}, 1000);          
                    /*
                    this.$bvToast.toast(this.$t("power_sockets.command_failed"), {
                        title: this.$t('notify.notice'),
                        variant: 'danger',
                        autoHideDelay: 2000,
                        toaster: 'paahdin'
                    })
                    */
                }).catch();
                    // Tarvitaanko eventtiä PowerSockets-sivulle siitä kun komento on lähetetty?
                    // Kuka päivittää status-pylpyrät käyttöliittymässä?
                    //.then(() => {
                    //    this.$emit('commandsent', { deviceId: this.value, command: action });
                    //})
            } else {
                //console.log(this.value);
            }
        }
    }
}

</script>
